import React from 'react';

export default function FailedSVG(){ 
 return <svg height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
 <circle cx="16" cy="16" r="16" fill="white"/>
 <g clipPath="url(#clip0)">
 <path d="M23.3301 20.1892L17.4282 8.38255C17.1558 7.83815 16.6087 7.5 16 7.5C15.3914 7.5 14.8443 7.83815 14.5718 8.38255L8.66991 20.1892C8.42066 20.688 8.44681 21.2688 8.74001 21.7429C9.03296 22.217 9.54076 22.5 10.0982 22.5H21.9019C22.4592 22.5 22.9671 22.217 23.26 21.7429C23.5532 21.2688 23.5794 20.688 23.3301 20.1892ZM22.4094 21.217C22.2984 21.3969 22.1133 21.5 21.9019 21.5H10.0982C9.88671 21.5 9.70166 21.3969 9.59061 21.217C9.47951 21.0373 9.47001 20.8257 9.56451 20.6365L15.4663 8.82985C15.5696 8.6233 15.7691 8.5 16 8.5C16.231 8.5 16.4304 8.6233 16.5337 8.82985L22.4356 20.6365C22.5301 20.8257 22.5205 21.0373 22.4094 21.217Z" fill="#EB3434"/>
 <path d="M16 18C16.2761 18 16.5 17.7761 16.5 17.5V11.5C16.5 11.2239 16.2761 11 16 11C15.7239 11 15.5 11.2239 15.5 11.5V17.5C15.5 17.7761 15.7239 18 16 18Z" fill="#EB3434"/>
 <path d="M16 20.5C16.5523 20.5 17 20.0523 17 19.5C17 18.9477 16.5523 18.5 16 18.5C15.4477 18.5 15 18.9477 15 19.5C15 20.0523 15.4477 20.5 16 20.5Z" fill="#EB3434"/>
 </g>
 <defs>
 <clipPath id="clip0">
 <rect width="16" height="20" fill="white" transform="translate(8 7)"/>
 </clipPath>
 </defs>
 </svg> 
}